// Recovery for a stale or mixed service-worker cache: after a deploy, a
// device that lost part of its precache (mobile browsers evict storage under
// pressure) can end up running chunks from two different builds. That
// surfaces as minified errors like "(0 , x.$2)(...) is not a function" or
// ChunkLoadError. Clearing every cache and service worker and reloading gets
// the device back onto a single build.

const RECOVER_AT_KEY = "staleBundleRecoverAt"
// One attempt per minute: if the error survives a clean reload it is a
// genuine bug, and the error screen should show instead of a reload loop.
const RECOVER_COOLDOWN = 60000

export const isStaleBundleError = (message) => {
  if (!message) {
    return false
  }
  return /ChunkLoadError|Loading( CSS)? chunk .+ failed|is not a function|Unexpected token '<'/i.test(message)
}

// Resolves false when recovery is not attempted (cooldown active or storage
// unavailable); otherwise clears caches and reloads the page.
export const recoverFromStaleBundle = async () => {
  try {
    const lastAt = Number(sessionStorage.getItem(RECOVER_AT_KEY))
    if (lastAt && Date.now() - lastAt < RECOVER_COOLDOWN) {
      return false
    }
    sessionStorage.setItem(RECOVER_AT_KEY, `${Date.now()}`)
  } catch (error) {
    return false
  }
  try {
    const registrations = (await navigator.serviceWorker?.getRegistrations()) || []
    await Promise.all(registrations.map((registration) => registration.unregister()))
    if (window.caches) {
      const keys = await caches.keys()
      await Promise.all(keys.map((key) => caches.delete(key)))
    }
  } finally {
    window.location.reload()
  }
  return true
}
